import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addpair } from "../../actions/perpetualActions";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';
import { Editor } from '@tinymce/tinymce-react';
import axios from "axios";
import keys from "../../actions/config";
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { t } from 'i18next';
const url = keys.baseUrl;

const options = [{ 'value': "On", 'label': "On" }, { 'value': "Off", 'label': "Off" }];

class PairAddModal extends React.Component {
    constructor() {
        super();
        this.state = {
            email_assigned: false,
            first_currency: "",
            tickerroot: "",
            initial_margin: "",
            maint_margin: "",
            interest_base_symbol: "",
            interest_quote_symbol: "",
            funding_premium_symbol: "",
            risk_limit: "",
            risk_step: "",
            minpriceincrement: "",
            maxpriceincrement: "",
            mark_price: "",
            contract_size: "",
            maxquantity: "",
            minquantity: "",
            lotsize: "",
            funding_interval: "",
            second_currency: "",
            leverage: "",
            maker_rebate: "",
            dailyinterest: "",
            taker_fees: "",
            markuppercentage: "",
            floatingDigits: "",
            bot: "",
            maxPrice: "",
            minPrice: "",
            errors: {},
        };
        // console.log(this.state,'statessssssssss');
        this.handleChange1 = this.handleChange1.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
    }

    styles = {
        option: (styles, {isFocused, isSelected}) => ({
            ...styles,
            color: "#fff",
            background: isFocused
                ? '#bdbdbd'
                : isSelected
                    ? '#005eb8'
                    : "#808080",
            zIndex: 1
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          height: '52px',
          padding: '0 6px',
          backgroundColor: "#03081f",
          borderColor: '#81c8f6',
        borderRadius: 10,
        borderStyle: 'solid',
        borderWidth: '1px'
         
        }),
        control: (provided, state) => ({
          ...provided,
          height: '52px',
          borderRadius:10,
          backgroundColor: "#03081f",
          border:'none'
         
        }),
        indicatorsContainer: (provided, state) => ({
          ...provided,
          height: '52px',
          position: 'absolute',
          right: 0,
          top: 0,
          color:'#fff' 
        }),    
        singleValue: (provided, state) => ({
          ...provided,
          color: "#fff"
        }),
        menuList: base => ({
            ...base,
            // kill the white space on first and last option
            padding: 0
          })
      };
    componentDidMount() {
        this.getData()
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            $("#add-spot-modal").find(".text-danger").show();
            this.setState({
                errors: nextProps.errors
            });
        }
        // console.log(nextProps);
        if (nextProps.auth !== undefined
            && nextProps.auth.perpetual !== undefined
            && nextProps.auth.perpetual.data !== undefined
            && nextProps.auth.perpetual.data.message !== undefined) {
            $('#add-spot-modal').modal('hide');
            toast(t(nextProps.auth.perpetual.data.message), {
                position: toast.POSITION.TOP_CENTER
            });
            nextProps.auth.perpetual = undefined;

        }
    }

    getData() {
        axios
            .get(url + "api/pair-data-first")
            .then(res => {

                console.log(res.data, 'datassss');
                var currencyarray = [];
                res.data.map((item, i) => {
                    const name = item.currencySymbol;
                    const value = item.currencySymbol;
                    const obj = { 'value': name, 'label': value };
                    currencyarray.push(obj);
                });
                // console.log(currencyarray,'currencyarray');
                this.setState({ first_currency1: currencyarray, email_assigned: true });
            })
            .catch()
        //  console.log(this.props,'authget1');
    }

    onChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };
    handleChange = selectedOption => {
        this.setState({ first_currency: selectedOption.value });
         console.log(`Option selected:`, selectedOption );
    };
    handleChange1 = selectedOption => {
        this.setState({ second_currency: selectedOption.value });
        //console.log(`Option selected:`, selectedOption );
    };
    handlebot = selectedbot => {
        this.setState({ botselected: selectedbot.value });
        //console.log(`Option selected:`, selectedOption );
    };


    onFaqAdd = e => {
        // if(this.state.first_currency != "" && this.state.second_currency != ""){
        //     if (this.state.first_currency == this.state.second_currency) {
            // toast("First currency and second currency cannot be same", {
            //     position: toast.POSITION.TOP_CENTER,
            // })
            // return false;
        //     alert()
        //     let errors = {};
        //     errors["first_currency"] = "First currency and second currency cannot be same"
        //     this.setState({
        //         errors : errors
        //     })
        // }
        // }        
        // else {
            e.preventDefault();
            const newcontract = {
                tickerroot: this.state.first_currency + this.state.second_currency,
                mark_price: this.state.mark_price,
                maxquantity: this.state.maxquantity,
                minquantity: this.state.minquantity,
                second_currency: this.state.second_currency,
                first_currency: this.state.first_currency,
                maker_rebate: this.state.maker_rebate,
                taker_fees: this.state.taker_fees,
                markuppercentage: this.state.markuppercentage,
                botstatus: this.state.botselected,
                floatingDigits: this.state.floatingDigits,
                maxPrice: this.state.maxPrice,
                minPrice: this.state.minPrice
            };
            // console.log(newcontract);
            this.props.addpair(newcontract);
            this.setState({
                email_assigned: false,
                first_currency: "",
                // first_currency1: "",
                tickerroot: "",
                initial_margin: "",
                maint_margin: "",
                interest_base_symbol: "",
                interest_quote_symbol: "",
                funding_premium_symbol: "",
                risk_limit: "",
                risk_step: "",
                minpriceincrement: "",
                maxpriceincrement: "",
                mark_price: "",
                contract_size: "",
                maxquantity: "",
                minquantity: "",
                lotsize: "",
                funding_interval: "",
                second_currency: "",
                leverage: "",
                maker_rebate: "",
                dailyinterest: "",
                taker_fees: "",
                markuppercentage: "",
                floatingDigits: "",
                bot: "",
                maxPrice: "",
                minPrice: "",
                errors: {}
            })
        // }
    };

    emptyState() {
        this.setState({
            email_assigned: false,
            first_currency: "",
           // first_currency1: "",
            tickerroot: "",
            initial_margin: "",
            maint_margin: "",
            interest_base_symbol: "",
            interest_quote_symbol: "",
            funding_premium_symbol: "",
            risk_limit: "",
            risk_step: "",
            minpriceincrement: "",
            maxpriceincrement: "",
            mark_price: "",
            contract_size: "",
            maxquantity: "",
            minquantity: "",
            lotsize: "",
            funding_interval: "",
            second_currency: "",
            leverage: "",
            maker_rebate: "",
            dailyinterest: "",
            taker_fees: "",
            markuppercentage: "",
            floatingDigits: "",
            bot: "",
            maxPrice: "",
            minPrice: "",
            errors: {}
        })
    }

    render() {
        const { errors } = this.state;
        const { selectedOption } = this.state.first_currency;
        const { selectedOption1 } = this.state.second_currency;
        const { selectedbot } = this.state.bot

        //      const options1 = [
        //   { value: 'USD', label: 'USD' },
        //   { value: 'INR', label: 'INR' },
        // ];

        return (
            <div>
                <div className="modal fade" id="add-spot-modal" data-reset="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">{t("ADD_PAIR")}</h4>
                                <button type="button" className="close" data-dismiss="modal" onClick = {()=> {this.emptyState()}}>&times;</button>
                            </div>
                            <div className="modal-body">
                                <form noValidate onSubmit={this.onFaqAdd} id="add-spot">
                                    <div className="row mt-2">

                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.tickerroot}
                                                id="tickerroot"
                                                type="number"
                                                error={errors.tickerroot}
                                                className="d-none" />

                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="taker_fees">{t("TAKER_FEES")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.taker_fees}
                                                error={errors.taker_fees}
                                                id="taker_fees"
                                                type="number"
                                                onKeyPress='return (event.charCodeAt !=72)'
                                                oninput="validity.valid||(value='');"
                                                className={classnames("form-control", {
                                                    invalid: errors.taker_fees
                                                })}
                                            />
                                            <span className="text-danger">{errors.taker_fees ? t("TAKER_FEES_REQUIRED"):""}</span>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="markuppercentage">{t("MARK_UP_PERCENTAGE")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.markuppercentage}
                                                error={errors.markuppercentage}
                                                id="markuppercentage"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.markuppercentage
                                                })}
                                            />
                                            <span className="text-danger">{errors.markuppercentage ? t("MARKUPPERCENTAGE_REQUIRED"):""}</span>
                                        </div>
                                    </div>



                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="maker_rebate">{t("MAKER_REBATE")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.maker_rebate}
                                                error={errors.maker_rebate}
                                                id="maker_rebate"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.maker_rebate
                                                })}
                                            />
                                            <span className="text-danger">{errors.maker_rebate ? t("MARKER_REBATE_REQIURED"):""}</span>
                                        </div>
                                    </div>


                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="mark_price">{t("MARKET_PRICE")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.mark_price}
                                                error={errors.mark_price}
                                                id="mark_price"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.mark_price
                                                })}
                                            />
                                            <span className="text-danger">{errors.mark_price ? t("MARKER_PRICE_REQIURED"):""}</span>
                                        </div>
                                    </div>



                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="maxquantity">{t("MAX_ORDER_QUANTITY")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.maxquantity}
                                                error={errors.maxquantity}
                                                id="maxquantity"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.maxquantity
                                                })}
                                            />
                                            <span className="text-danger">{errors.maxquantity ? t("MAX_QUANTITY_REQIURED"):""}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="minquantity">{t("MAX_ORDER_QUANTITY")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.minquantity}
                                                error={errors.minquantity}
                                                id="minquantity"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.minquantity
                                                })}
                                            />
                                            <span className="text-danger">{errors.minquantity ? t("MIN_QUANTITY_FIELD_REQIURED"):""}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="maxPrice">{t("MAX_PRICE")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.maxPrice}
                                                error={errors.maxPrice}
                                                id="maxPrice"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.maxPrice
                                                })}
                                            />
                                            <span className="text-danger">{errors.maxPrice ? t("MAX_PRICE_REQIURED"):""}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="minPrice">{t("MIN_PRICE")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.minPrice}
                                                error={errors.minPrice}
                                                id="minPrice"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.minPrice
                                                })}
                                            />
                                            <span className="text-danger">{errors.minPrice ? t("MIN_PRICE_REQIURED"):""}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="minquantity">{t("FLOATING_DIGITAL")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.floatingDigits}
                                                error={errors.floatingDigits}
                                                id="floatingDigits"
                                                type="number"
                                                className={classnames("form-control", {
                                                    invalid: errors.floatingDigits
                                                })}
                                            />
                                            <span className="text-danger">{errors.floatingDigits ?t("FLOATING_FILELD_REQIURED"):""}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="first_currency">{t("FIRST_CURRENCY")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <Select isSearchable={false}
                                                value={selectedOption}
                                                onChange={this.handleChange}
                                                options={this.state.first_currency1}
                                                styles={this.styles} className="border_blue_select"
                                            />
                                            <span className="text-danger">{errors.first_currency ? t("FIRST_CURRENCY_REQIURED"):""}</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="second_currency">{t("SECOND_CURRENCY")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <Select isSearchable={false}
                                                value={selectedOption1}
                                                onChange={this.handleChange1}
                                                options={this.state.first_currency1}
                                                styles={this.styles} className="border_blue_select"

                                            />
                                            <span className="text-danger">{errors.second_currency ?t("SECOND_CURRENCY_REQIURED"):""}</span>
                                        </div>
                                    </div>



                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="autobot">{t("BINANCE_INTEGRATION")}</label>
                                        </div>
                                        <div className="col-md-9">
                                            <Select isSearchable={false}
                                                value={selectedbot}
                                                onChange={this.handlebot}
                                                options={options}
                                                styles={this.styles} className="border_blue_select"

                                            />
                                            {/* <span className="text-danger">{errors.second_currency}</span> */}
                                        </div>
                                    </div>

                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline" data-dismiss="modal" onClick = {()=> {this.emptyState()}}>{t("CLOSE")}</button>
                                <button
                                    form="add-spot"
                                    type="submit"
                                    className="btn btn-primary">
                                    {t("ADD_CONTRACT")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

PairAddModal.propTypes = {
    addpair: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { addpair }
)(withRouter(PairAddModal));
